// Google map api
export const GoogleMapApiKey = "AIzaSyCYykh_jLfoa8Ho56GC_Nl1OBn3dpUjsPs";

// Tiny MCE api
export const TinyMceKey = "x1yp4nvlgrxh6dr9lp9nhisshp27dpx8puhvn5j9n5wglqx9";

// Google map libraries
export const GoogleMapLibraries = ["places"];

// Google oauth client id
export const GoogleClientId = "1045784563447-u9ea3nhqoc0gerj0gbdsatsr7duf40v4.apps.googleusercontent.com";